export const filterTotalsByMostRecentDateVisitor = () => (args) => {
    if (args?.visitable?.length) {
        for (let i = 0; i < args.visitable.length; i += 1) {
            const totals = args.visitable[i]?.totals;
            if (totals && totals.length) {
                const mostRecentDate = new Date(Math.max(...totals.map((s) => s.date?.getTime() || 0)));
                args.visitable[i].totals = totals.filter((d) => (d.date?.getTime() || 0) === (mostRecentDate?.getTime() || 0));
            }
        }
    }
};
